/** A quick filter chip rendered in the row above the results grid. */
export interface QuickFilter {
  key: string;
  label: string;
  /** Chips that carry a leading glyph in production (Insider, Top Shop). */
  icon?: "insider" | "topShop";
}

/** Mirrors the chip row on production Faire search results. */
export const QUICK_FILTERS: QuickFilter[] = [
  { key: "low-minimum", label: "Low minimum" },
  { key: "hide-previously-seen", label: "Hide previously seen" },
  { key: "california-brands", label: "California brands" },
  { key: "insider", label: "Insider", icon: "insider" },
  { key: "top-shop", label: "Top Shop", icon: "topShop" },
  { key: "bestsellers", label: "Bestsellers" },
  { key: "no-import-duties", label: "No import duties" },
];
